



































import {Component, Vue, Prop} from "vue-property-decorator";
import {namespace} from "vuex-class";

import {Languages, LanguageList} from "@/constants/locale";
import {ANALYTIC_CLICKS} from "@/services/Analytics";


const profileModule = namespace("profile");

@Component({
  name: "LanguageSelector",
})
export default class LanguageSelector extends Vue {
  @Prop({default: Languages.es})
  private value!: Languages;

  @Prop({default: false})
  private inverse!: boolean;

  @Prop({default: false})
  private dropDown!: boolean;

  private languageList = LanguageList;
  private languageMenuVisible: boolean = false;

  private selectFlag(lang: Languages) {
    ANALYTIC_CLICKS.changeLanguage(this.$gtag, lang);
    this.$emit("input", lang);
    this.languageMenuVisible = false;
  }

  private toggleLanguageMenu() {
    this.languageMenuVisible = !this.languageMenuVisible;
  }

}
